import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async createCompany({ commit }, data) {
      try {
        return await api.post('/ethos/companies', data)
      } catch (error) {
        throw error
      }
    },

    async getCompanies({ commit }) {
      try {
        const response = await api.get('/ethos/companies')
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getCompany({ commit }, id) {
      try {
        const response = await api.get(`/ethos/companies/${id}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getNumUsers({ commit }) {
      try {
        const response = await api.get('/company/numUsuarios')
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateCompany({ commit }, data) {
      try {
        return await api.put(`/ethos/companies/${data.id}`, data)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
